<template>
  <div class="header-search pt-1 d-flex flex-row align-items-lg-center">
    <input  class="search-bar-input"
            @keyup.enter="submit"
             v-model="keywords"
             placeholder="Address,Tx Hash,Block"/>
    <img @click="submit" src="../../images/search/search.png"/>
  </div>
</template>

<script>
import { isAddress, isTx, isHeight } from '@/util/index'

    export default {
        name: 'headerSearch',
        components: {},
        props: [
        ],
        data() {
            return {
              input: null,
              border: null,

              keywords: '',
              searchType: '',
              isActive: false,
              isWait: false,
              stot: 0,
              search_input: '',

            }
        },
        computed: {},
        watch: {
          keywords (key) {
            if (isAddress(key)) {
              this.isActive = true
              this.searchType = 'address'
            } else if (isTx(key)) {
              this.isActive = true
              this.searchType = 'transactinon'
            } else if (isHeight(key)) {
              this.isActive = true
              this.searchType = 'block'
            } else {
              this.isActive = false
              this.searchType = ''
            }
          }

        },

        methods: {
          submit () {
            if (!this.isActive) {
              return
            }
            this.isActive = false
            this.input.blur()
            this.isWait = true
            const key = this.keywords
            switch (this.searchType) {
              case 'address':
                return this.searchAddress(key)
              case 'transactinon':
                return this.searchTx(key)
              case 'block':
                return this.searchBlock(key)
              default:
                return
            }
            this.keywords=''

          },
          searchAddress (key) {
            this.$router.push(`/address/${key}`)
            this.isWait = false
            this.keywords=''
          },
          searchTx (key) {
            this.$router.push(`/tx/${key}`)
            this.isWait = false
            this.keywords=''
          },
          searchBlock (key) {
            this.$router.push(`/block/${key}`)
            this.isWait = false
            this.keywords=''
          }
        },
        created() {

        },
        mounted() {
          this.input = this.$el.querySelector('.search-bar-input')
        }
        //beforeDestroy() {},
        //update() {},
        //activited() {},
        //beforeRouteUpdate() {},
        //filters: {},
    };
</script>

<style lang="scss" scoped>
    .header-search{
      width: 630px;
        border-radius: 10px;
        border: 1px solid #3772ff;
        box-sizing: border-box;
        box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.05);
        height: 35px;
        //min-width: 230px;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;


        input{
            -webkit-appearance: none;
            border: none;
            background-color: transparent;
            height: 100%;
            padding-left: 35px;
            outline: none;
            width: 100%;

            &:focus{
                &~.sp-res-box{
                    display: block;
                }
            }
        }

        img {
          cursor: pointer;
          width: 20px;
          height: 19px;
          margin-right: 21px;
        }

        .sp-res-box{
            position: absolute;
            top: 34px;
            left: 0;
            right: 0;
            padding-top: 5px;
            z-index: 9;
            display: none;

            &:hover{
                display: block;
            }

            .sp-res-card{
                margin: 0 5px;
                border-radius: 15px;
                background-color: #fff;
                box-shadow: 0px 1px 3px rgba(0,0,0,0.1);

                a{
                    display: block;
                    &:hover{
                        background-color: rgba(0,0,0,0.03);
                    }
                }
            }
        }
    }
</style>
